import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=bccdd3c2&scoped=true"
import script from "./shop.vue?vue&type=script&lang=ts"
export * from "./shop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccdd3c2",
  null
  
)

export default component.exports